import { useMutation } from '@apollo/client';
import { CREATE_CATEGORY_MUTATION } from '../../mutations';

export function useCreateCategoryMutation() {
    return useMutation( CREATE_CATEGORY_MUTATION );
}
